
import { Box, Card, /* Checkbox, FormControlLabel, */ Grid, TableCell, TableRow, TextField, Typography } from '@mui/material';
import {
  MRT_RowData,
  MaterialReactTable,
  useMaterialReactTable, //import alternative sub-component if we do not want toolbars
  type MRT_ColumnDef,
  type MRT_TableOptions
} from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { PaginationState } from "@tanstack/react-table";
import { useEffect, useState } from 'react';

interface SampleTableProps<T extends MRT_RowData> extends MRT_TableOptions<T> {
  columns: MRT_ColumnDef<T>[];
  data: T[];
  allData?: T[];
  pagination: PaginationState | undefined
  setPagination: any
  rowCount: number
  rowNumber?: boolean;
  enablePagination?: boolean;
  density?: 'comfortable' | 'compact' | 'spacious';
  // enableTopToolbar?: boolean;
  isLoading?: boolean;
  //suma
  enableRowSelection?: boolean;
  enableSubTotalCalculation?: boolean;
  totalField?: keyof T;
  enableTaxSelection?: boolean;
  onTotalsChange?: (totals: { subtotal: number; iva: number; total: number; totalDescuento: number, iva_producto: number, }) => void
  initialTaxtPorcentaje?: number | null
}

const SampleTablePaginationOrden = <T extends MRT_RowData>({
  columns,
  data,
  allData,
  density = 'comfortable',
  rowNumber = false,
  // enableTopToolbar = false,
  isLoading = false,
  pagination,
  setPagination,
  rowCount,
  //suma
  enableRowSelection = false,
  enableSubTotalCalculation = false,
  //totalField,
  enableTaxSelection = false,
  onTotalsChange,
  initialTaxtPorcentaje
  /* initialTaxtPorcentaje = 15 */


}: SampleTableProps<T>) => {

  //
  console.log('porcentaje', initialTaxtPorcentaje)
  //****Suma
  const [rowSelection, /* setRowSelection */] = useState<Record<string, boolean>>({});
  const [subTotal, setSubTotal] = useState(0)
  const [iva, setIva] = useState(0)
  const [totalgeneral, setTotalGeneral] = useState(0)
  const [applyTax, /* setApplyTax */] = useState(true);
  const [taxPercentage, setTaxPercentage] = useState(15)
  /* const [taxPercentage, setTaxPercentage] = useState<number>(() => {
    // si initialTaxtPorcentaje es >0 lo usamos, si no ponemos 15
    return initialTaxtPorcentaje && initialTaxtPorcentaje > 0 ? initialTaxtPorcentaje : 15;
  }); */

  useEffect(() => {
    // si cambia el valor de edición, actualizamos
    //setTaxPercentage(initialTaxtPorcentaje && initialTaxtPorcentaje > 0 ? initialTaxtPorcentaje : 15);
    if (initialTaxtPorcentaje!=null) {
      setTaxPercentage(initialTaxtPorcentaje)
    } 

  }, [initialTaxtPorcentaje]);


  useEffect(() => {
    if (!enableSubTotalCalculation) return;

    const dataAux = allData && allData.length > 0 ? allData : data
    const rowsToCalculate = enableRowSelection
      ? dataAux.filter((_, index) => rowSelection[index.toString()])
      : dataAux

    /* const rowsToCalculate = enableRowSelection
      ? data.filter((_, index) => rowSelection[index.toString()]) // Usar índice como string
      : data; */

    const SubTotal = Math.round(
      rowsToCalculate.reduce((sum, row) => {
        const cantidad = Number(row.cantidad) || 0;
        const precio = Number(row.precio_compra) || 0;
        const descuento = Number(row.descuento) || 0;
        const totalProducto = cantidad * precio - descuento;

        return sum + totalProducto;
      }, 0) * 1000
    ) / 1000;

    ///descuento
    const totalDescuento = Math.round(
      rowsToCalculate.reduce((sum, row) => sum + (Number(row.descuento) || 0), 0) * 1000

    ) / 1000

    //const des = Number()
    const iva_producto = taxPercentage / 100
    ///2. calcular Iva
    const ivaRow = SubTotal * (taxPercentage / 100); // para dividir el porcentaje
    const newIva = Math.round(ivaRow * 10000) / 10000;  /// decimales multimplica 1000

    //3. calcular el total general
    const rowTotal = SubTotal + newIva
    const newTotal = Math.round(rowTotal * 10000) / 10000;
    //const newTotal = Math.round((subTotal + newIva) * 1000) / 1000



    setSubTotal(SubTotal)
    setIva(newIva)
    setTotalGeneral(newTotal)
    if (onTotalsChange) {
      onTotalsChange({
        subtotal: SubTotal,
        iva: newIva,
        total: newTotal,
        totalDescuento: totalDescuento,
        iva_producto: iva_producto,
        //iva_porcentaje: iva_producto
      })
    }

  }, [allData, data, rowSelection, enableRowSelection, enableSubTotalCalculation, applyTax, taxPercentage]);

  const taxtControl = enableTaxSelection && (

    <Box sx={{ display: 'flex', gap: 2, alignItems: "center" }}>
      {/* <FormControlLabel
        control={
          <Checkbox
            disabled={true}
            checked={applyTax}
            onChange={(e) => setApplyTax(e.target.checked)}
          />
        }
        label="Aplicar IVA"
      /> */}
      <Typography fontWeight={600}>{"Aplicación de IVA"}</Typography>
      {applyTax && (
        <TextField
          label="%IVA"
          type='text'
          value={taxPercentage}
          onChange={(e) => {
            let value = Math.min(Math.max(Number(e.target.value), 0), 100);

            setTaxPercentage(value);
          }}
          inputProps={{ min: 0, max: 100 }}
          size='small'
          sx={{ width: '80px' }}
        />
      )}
    </Box>
  )


  const table = useMaterialReactTable({
    columns,
    data,
    localization: MRT_Localization_ES,
    enableRowNumbers: rowNumber,
    enableRowVirtualization: rowNumber,
    enableColumnFilters: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableColumnActions: false,
    enableRowActions: false,
    enableTopToolbar: true,
    state: {
      //rowSelection, 
      expanded: true,
      density: density,
      isLoading: isLoading,
      pagination: pagination
    },

    ///* pagniacion
    enablePagination: true,
    manualPagination: true,
    rowCount: rowCount,
    onPaginationChange: setPagination,

    ///* estilos
    muiTablePaperProps: {

      elevation: 0,
    },
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 15, 20],
      showRowsPerPage: true,
      showFirstButton: true,
      showLastButton: true,
    },
    muiTableBodyCellProps: {
      align: 'center',
    },
    muiTableHeadCellProps: {
      align: 'center',
    },
    renderTopToolbarCustomActions: () => (
      <>
        <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
          Total de Registros: {rowCount}
        </Typography>

      </>

    ),
  });

  return (
    <Card>
      <Box sx={{ width: '100%', p: 2 }}>
        <MaterialReactTable table={table} />

        <Box mt={4}>
          <Grid container justifyContent="flex-end">
            <Grid item xs={12} sm={6} md={4}>
              <Box display="flex" flexDirection="column" alignItems="flex-end" gap={1}>
                {taxtControl}

                {enableSubTotalCalculation && (
                  <TableRow>
                    <TableCell colSpan={2}><strong>SubTotal:</strong></TableCell>
                    <TableCell align='right'>
                      {subTotal.toLocaleString('es-ES', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 4
                      })}
                    </TableCell>
                  </TableRow>

                )}

                {applyTax && (
                  <TableRow>
                    <TableCell colSpan={2}><strong> + IVA ({taxPercentage}%)</strong></TableCell>
                    <TableCell align='right'>
                      {iva.toLocaleString('es-ES', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 4
                      })}
                    </TableCell>

                  </TableRow>

                )}

                <TableRow>
                  <TableCell colSpan={2}><strong>{'Total a pagar'}</strong></TableCell>
                  <TableCell align='right'>
                    {totalgeneral.toLocaleString('es-ES', {
                      style: 'currency',
                      currency: 'USD',
                      minimumFractionDigits: 4
                    })}
                  </TableCell>
                </TableRow>

              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Card>
  );

};

export default SampleTablePaginationOrden;
